import IUser from "../entities/IUser";
import Axios from "./Axios";
import { API, DEFAULT_API_BASE_URL } from "../config";

const URL = API || DEFAULT_API_BASE_URL;

// Goes through the shared Axios instance so the Authorization header,
// automatic token refresh and 401 handling apply to these calls too.
export const get = async (method: string) => {
  const path = method.startsWith("/") ? method : `/${method}`;
  const res = await Axios.get(path);
  return res.data;
};

const fortmatResponse = (res: any) => {
  return JSON.stringify(res, null, 2);
};

export const post = async (postData: any) => {
  const response = await fetch(`${"URL"}/users`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(postData),
  });
  const data = await response.json();

  if (!response.ok) {
    console.log(data.description);
    throw new Error(data.message || "Could not fetch categories.");
    return;
  }

  return data;
};
